import { useAuth0 } from '@auth0/auth0-react';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import LoadingButton from '@mui/lab/LoadingButton';

import { useDispatch } from 'react-redux';
import {
    Box,
    styled,
    Typography,
    Paper,
    Skeleton,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Avatar,
    Divider,
    Chip,
    Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useEffect, useState } from 'react';
import sendNotification from '../../utils/sendNotification';
import { confirmNetwork } from '../../redux/ProfileSlice';

import axios from 'axios';

const hrBox = styled('div')(({ theme }) => ({
    position: 'relative',
}));
const BookingButton = styled(LoadingButton)(({ theme }) => ({
    color: 'white',
    padding: '6px 0px',
    width: '100%',
    maxWidth: '130px',
    borderRadius: '50px',
    marginTop: '15px',
    [theme.breakpoints.down('md')]: {
        padding: '6px 0px',
        marginTop: '15px',
    },
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        fontSize: '12px',
        maxWidth: '100px',
    },
}));

const SummaryContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',

    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
    },
}));
const SummaryContentBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'left',
        alignItems: 'flex-start',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        gap: '1rem',
    },
}));
const StyleDivider = styled(Divider)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        '&::before': {
            content: '""',
            width: '0px',
        },
    },
}));
export const NetworkRequest = props => {
    const { getAccessTokenSilently } = useAuth0();
    const dispatch = useDispatch();
    const [loadingAccept, setLoadingAccept] = useState(false);
    const [loadingReject, setLoadingReject] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [schoolData, setSchoolData] = useState([]);
    const [loadingSchoolData, setLoadingSchoolData] = useState(false);
    const [schoolInNetwork, setSchoolInNetwork] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [pending, setPending] = useState(0);
    const [network, setNetwork] = useState('');

    const accept = async status => {
        try {
            setButtonDisabled(true);
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            const requestData = {
                token,
                request: {
                    pk1: status.pk1,
                    sk1: status.sk1,
                    outcome: status.action,
                },
            };
            //TO DO: This needs to switch based on the user being a crt or school
            const sendNetworkOutcome = await dispatch(
                confirmNetwork(requestData)
            );

            if (sendNetworkOutcome.payload?.status === 200) {
                sendNotification('success', 3000, 'Network request success');
            } else {
                sendNotification('error', 6000, 'Failed request');
            }
        } catch (error) {
            sendNotification('error', 6000, 'Error Request');
        } finally {
            setButtonDisabled(false);
        }
    };

    const getSchoolList = async (token, schoolId) => {
        try {
            const output = await axios.get('/getSchoolList', {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params: {
                    search: schoolId,
                    exact: true,
                },
            });
            return output;
        } catch (err) {
            throw err;
        }
    };

    const getSchoolPromise = (token, schoolId) => {
        return getSchoolList(token, schoolId);
    };

    const getNetworkConnectionPromise = (token, networkName) => {
        return new Promise(async (resolve, reject) => {
            const requestData = {
                'token': token,
                'request': { 'networkName': networkName },
            };
            const output = await axios
                .post('/getNetwork', requestData.request, {
                    baseURL: process.env.REACT_APP_API_GATEWAY,
                    url: `/getNetwork`,
                    timeout: 30000,
                    headers: {
                        authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                })
                .catch(err => reject(err));
            resolve(output);
        });
    };

    const processNetworkData = async () => {
        if (props.profile.network !== undefined && schoolData.length === 0) {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            setLoadingSchoolData(true);

            try {
                //if the school data for the schools that invited this user existss, do nothing, else go get the school data
                const networkRequests = props.profile.network.map(
                    async school => {
                        if (
                            schoolData.length === 0 ||
                            !schoolData.some(
                                obj => obj.pk1 === school.invitedBySchool
                            )
                        ) {
                            return await getSchoolPromise(
                                token,
                                school.invitedBySchool
                            );
                        }
                    }
                );

                //make multiple calls to get the data for the schools that invited this user
                setSchoolData(
                    (await Promise.allSettled(networkRequests))
                        .filter(response => response.status === 'fulfilled')
                        .map(
                            response => response.value.data.schools.Message.Data
                        )
                        .flat(2)
                );

                //Returns the details of the other schools in the network that the user has been invited to join
                const networkConnection = props.profile.network.map(
                    async school => {
                        return await getNetworkConnectionPromise(
                            token,
                            school['gs1-pk']
                        );
                    }
                );
                // const outcome2 = networkConnection;
                const outcome2 = await Promise.allSettled(networkConnection);
                // console.log('outcome', outcome);
                console.log('outcome2', outcome2);
                console.log('setSchoolData', schoolData);
                const outputFlattened2 = outcome2.map((response, index) => ({
                    ...props.profile.network[index],
                    list: response.value.data.Message.Data.Items,
                }));

                setSchoolInNetwork(outputFlattened2);
            } finally {
                setLoadingSchoolData(false);
            }
        }
    };

    useEffect(() => {
        if (props.profile.network !== undefined) {
            const countPending = props.profile.network.reduce((count, item) => {
                return item.status === 'pending' ? count + 1 : count;
            }, 0);

            setPending(countPending);
            const filteredList = props.profile.network.filter(
                item => item.status === 'accepted'
            );
            setNetwork(filteredList[0]);
        }
    }, [props.profile.network]);

    useEffect(() => {
        processNetworkData();
    }, [props.profile.network]);

    // console.log('school in network', schoolInNetwork, schoolData);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // if (schoolData.length > 0 && !loadingSchoolData) {
    //     props.profile.network.map((ntwrk, index) => {
    //         const data = schoolData.filter(
    //             school => school?.pk1 === ntwrk?.invitedBySchool
    //         )[0].displayName;

    //         console.log(data);
    //     });
    // }
    return (
        <Box sx={{ width: '100%' }}>
            {props.profile.network !== undefined ? (
                <>
                    {pending > 0 && props.profile.type === 'Teacher' && (
                        <Typography variant="h3" sx={{ textAlign: 'left' }}>
                            Invitations
                        </Typography>
                    )}

                    {props.profile.type === 'School' && pending > 0 && (
                        <>
                            <StyleDivider textAlign="center">
                                <Typography sx={{ color: '#b4bcc4' }}>
                                    OR
                                </Typography>
                            </StyleDivider>
                            <Typography variant="h3" sx={{ textAlign: 'left' }}>
                                Join an existing network
                            </Typography>
                        </>
                    )}

                    {pending === 0 &&
                        network &&
                        network['gs1-pk'] !== undefined && (
                            <Typography variant="h3" sx={{ textAlign: 'left' }}>
                                {network['gs1-pk']}
                            </Typography>
                        )}

                    {props.profile.network.map((ntwrk, index) => {
                        if (
                            ntwrk.role !== 'admin' &&
                            ntwrk.status === 'pending'
                        ) {
                            const schoolDataItem = schoolData.find(
                                school => school?.pk1 === ntwrk?.invitedBySchool
                            );

                            return (
                                //TODO: Show logo of the inviting school. Show all the schools that are attached to that network. This could be a long list so it would need to be in an accordion

                                <Paper
                                    key={index}
                                    sx={{
                                        margin: '14px auto',
                                        maxWidth: 980,
                                    }}
                                >
                                    {/*console.log('status->ntwrk', ntwrk)*/}
                                    <Accordion
                                        expanded={expanded === `${index}`}
                                        onChange={handleChange(
                                            `${index}`,
                                            ntwrk.invitedBySchool
                                        )}
                                    >
                                        <AccordionSummary
                                            expandIcon={
                                                <ExpandMoreIcon
                                                    sx={{
                                                        alignSelf: 'flex-start',
                                                        marginTop: '3%',
                                                    }}
                                                />
                                            }
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                            sx={{
                                                '& .MuiAccordionSummary-expandIconWrapper':
                                                    {
                                                        alignSelf: 'flex-start',
                                                        marginTop: '3%',
                                                    },
                                            }}
                                        >
                                            <SummaryContent>
                                                <SummaryContentBox>
                                                    {schoolData.length > 0 &&
                                                    loadingSchoolData !==
                                                        true ? (
                                                        <Avatar
                                                            alt={`${schoolDataItem.displayName}`}
                                                            loading="lazy"
                                                            src={
                                                                schoolDataItem.schoolLogo
                                                            }
                                                            sx={{
                                                                marginRight:
                                                                    '1rem',
                                                                width: '60px',
                                                                height: '60px',
                                                                borderRadius:
                                                                    '3px',
                                                            }}
                                                        />
                                                    ) : (
                                                        <Skeleton
                                                            variant="rectangular"
                                                            width="60px"
                                                            height="60px"
                                                            sx={{
                                                                marginRight:
                                                                    '1rem',
                                                            }}
                                                        />
                                                    )}

                                                    <Box
                                                        sx={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'flex-start',
                                                            alignSelf:
                                                                'self-start',
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="subtitle2"
                                                            sx={{
                                                                width: '100%',
                                                                textAlign:
                                                                    'left',
                                                            }}
                                                        >
                                                            {ntwrk.status ===
                                                            'pending'
                                                                ? 'Join the Network: '
                                                                : 'Network name: '}
                                                            {ntwrk['gs1-pk']}
                                                        </Typography>
                                                        <Typography
                                                            variant="subtitle2"
                                                            sx={{
                                                                width: '100%',
                                                                textAlign:
                                                                    'left',
                                                                display: 'flex',
                                                            }}
                                                        >
                                                            {schoolData.length >
                                                                0 &&
                                                            loadingSchoolData !==
                                                                true ? (
                                                                `Requested by: ${schoolDataItem.displayName}`
                                                            ) : (
                                                                <Skeleton
                                                                    variant="rectangular"
                                                                    width="80%"
                                                                    height={24}
                                                                    sx={{
                                                                        borderRadius:
                                                                            '4px',
                                                                        marginLeft:
                                                                            '4px',
                                                                    }}
                                                                />
                                                            )}
                                                            <br />
                                                        </Typography>
                                                        <Typography
                                                            variant="subtitle2"
                                                            sx={{
                                                                width: '100%',
                                                                textAlign:
                                                                    'left',
                                                            }}
                                                        >
                                                            {/*  Status:{' '}
                                                        {ntwrk.status}*/}
                                                        </Typography>
                                                    </Box>
                                                </SummaryContentBox>
                                                {ntwrk.status === 'pending' && (
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            columnGap: '1rem',
                                                        }}
                                                    >
                                                        <BookingButton
                                                            size="small"
                                                            variant="contained"
                                                            loading={
                                                                loadingAccept
                                                            }
                                                            loadingPosition="start"
                                                            startIcon={
                                                                <ThumbUpIcon />
                                                            }
                                                            disabled={
                                                                buttonDisabled
                                                            }
                                                            onClick={e => {
                                                                e.stopPropagation();
                                                                accept({
                                                                    action: 'accept',
                                                                    pk1: ntwrk.pk1,
                                                                    sk1: ntwrk.sk1,
                                                                });
                                                            }}
                                                            sx={{
                                                                background:
                                                                    '#28a745',

                                                                '&:hover': {
                                                                    background:
                                                                        '#1b7a31',
                                                                },
                                                            }}
                                                        >
                                                            Accept
                                                        </BookingButton>
                                                        <BookingButton
                                                            size="small"
                                                            variant="contained"
                                                            loading={
                                                                loadingReject
                                                            }
                                                            loadingPosition="start"
                                                            startIcon={
                                                                <ThumbDownIcon />
                                                            }
                                                            disabled={
                                                                buttonDisabled
                                                            }
                                                            onClick={e => {
                                                                e.stopPropagation();
                                                                accept({
                                                                    action: 'decline',
                                                                    pk1: ntwrk.pk1,
                                                                    sk1: ntwrk.sk1,
                                                                });
                                                            }}
                                                            sx={{
                                                                background:
                                                                    '#dc3545',

                                                                '&:hover': {
                                                                    background:
                                                                        '#c23b47',
                                                                },
                                                            }}
                                                        >
                                                            Decline
                                                        </BookingButton>
                                                    </Box>
                                                )}
                                            </SummaryContent>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <StyleDivider textAlign="left">
                                                <Chip
                                                    label="Schools in Network"
                                                    color="primary"
                                                />
                                            </StyleDivider>
                                            <br />
                                            {schoolInNetwork.length > 0 &&
                                                schoolInNetwork[index].list !==
                                                    undefined && (
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        justifyContent="start"
                                                    >
                                                        {schoolInNetwork[
                                                            index
                                                        ].list.map(item => {
                                                            return (
                                                                <div
                                                                    key={
                                                                        item[
                                                                            'gs1-pk'
                                                                        ]
                                                                    }
                                                                    style={{
                                                                        margin: '8px 1rem',
                                                                    }}
                                                                >
                                                                    <Grid
                                                                        item
                                                                        key={
                                                                            item.pk1
                                                                        }
                                                                    >
                                                                        <Chip
                                                                            avatar={
                                                                                <Avatar
                                                                                    alt={
                                                                                        item.displayName
                                                                                    }
                                                                                    src={
                                                                                        item.schoolLogo
                                                                                    }
                                                                                />
                                                                            }
                                                                            label={
                                                                                item.displayName
                                                                            }
                                                                            variant="outlined"
                                                                        />
                                                                        {/* <Tooltip
                                                                                title={
                                                                                    item.displayName
                                                                                }
                                                                                arrow
                                                                            >
                                                                                <Avatar
                                                                                    alt={
                                                                                        item.displayName
                                                                                    }
                                                                                    src={
                                                                                        item.schoolLogo
                                                                                    }
                                                                                />
                                                                                <Typography>
                                                                                    {
                                                                                        item.displayName
                                                                                    }
                                                                                </Typography>
                                                                            </Tooltip> */}
                                                                    </Grid>
                                                                </div>
                                                            );
                                                        })}
                                                    </Grid>
                                                )}
                                        </AccordionDetails>
                                    </Accordion>
                                </Paper>
                            );
                        }
                    })}
                </>
            ) : (
                <Paper>
                    <Typography variant="h6" sx={{ margin: '16px' }}>
                        You dont have any invitations to join a school or
                        network of schools exclusively{' '}
                    </Typography>
                </Paper>
            )}
        </Box>
    );
};

export default NetworkRequest;
